import { render } from "./Clickbank.vue?vue&type=template&id=5f368436"
import script from "./Clickbank.vue?vue&type=script&lang=js"
export * from "./Clickbank.vue?vue&type=script&lang=js"
script.render = render

export default script